import { render } from "./page2.vue?vue&type=template&id=0b86981a&scoped=true"
import script from "./page2.vue?vue&type=script&lang=js"
export * from "./page2.vue?vue&type=script&lang=js"

import "./page2.vue?vue&type=style&index=0&id=0b86981a&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b86981a"]])

export default __exports__